interface Props {
  name: string
  coverUrl: string | null | undefined
  /** The gym's colour, for the stand-in when there is no photo. */
  color?: string | null
  className?: string
  children?: React.ReactNode
}

/**
 * A gym's cover photo, darkened at the foot so white text on it reads.
 *
 * A gym that has not uploaded one gets its own colour as a soft gradient
 * rather than a grey box, so the card still looks like that gym.
 */
export function GymCover({ name, coverUrl, color, className = '', children }: Props) {
  const base = color ?? '#6b7280'
  return (
    <div
      className={`relative overflow-hidden bg-content2 ${className}`}
      style={
        coverUrl
          ? undefined
          : {
              background: `linear-gradient(140deg, color-mix(in srgb, ${base} 35%, white), color-mix(in srgb, ${base} 85%, black))`,
            }
      }
    >
      {coverUrl && (
        <img
          src={coverUrl}
          alt={name}
          className="absolute inset-0 h-full w-full object-cover"
          loading="lazy"
        />
      )}
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-b from-transparent from-40% to-black/55"
      />
      {children}
    </div>
  )
}
